/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TradeOnboardingCoachmarkConditionalLoader_item = {
    readonly serviceId: string | null;
    readonly " $refType": "TradeOnboardingCoachmarkConditionalLoader_item";
};
export type TradeOnboardingCoachmarkConditionalLoader_item$data = TradeOnboardingCoachmarkConditionalLoader_item;
export type TradeOnboardingCoachmarkConditionalLoader_item$key = {
    readonly " $data"?: TradeOnboardingCoachmarkConditionalLoader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"TradeOnboardingCoachmarkConditionalLoader_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeOnboardingCoachmarkConditionalLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b85597d13658b133a50c92954559b8e0';
export default node;
